<template lang="pug">
  .component-client-action-buttons(v-if="entity")
    ul.dropdown.menu(v-if="item && canDo", data-dropdown-menu='', v-f="")
      li
        a(href='#Item-1') Action
        ul.menu
          li(v-if="canApprove")
            a(v-on:click="approve") Approve
          li(v-if="canReactivate")
            a(v-on:click="reactivate") Reactivate
          li(v-if="canSuspend")
            a(v-on:click="suspend") Suspend
          li(v-if="canDelete")
            a(v-on:click="deleteDriver") Delete
          li(v-if="canEdit")
            a(v-on:click="edit") Edit
          li(v-if="canResetPassword")
            a(v-on:click="setNewPassword") Set new Password
          li(v-if="canSendResetPassword")
            a(v-on:click="sendPasswordResetEmail") Request password reset
          li
            AddDriverFlagReveal(:item="entity")

    .dropdown-buttons(v-else-if="canDo")
      button.button.success(type="button", v-on:click="approve", v-if="canApprove") Approve
      button.button.success(type="button", v-on:click="reactivate", v-if="canReactivate") Reactivate
      button.button.warning(type="button", v-on:click="suspend", v-if="canSuspend") Suspend
      button.button.alert(type="button", v-on:click="deleteDriver", v-if="canDelete") Delete
    .dropdown-buttons(v-else-if="pendingDelete")
      ActionButton(:action="deleteClientAccount", :confirm="true") Delete client account

    .dropdown-buttons(v-else)
      p No actions available

</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import MaggieHelper from 'src/maggieHelper'
import DriverSmartEdit from 'components/backoffice/smartedits/DriverEdit'
import DriverEditPassword from 'components/backoffice/smartedits/DriverEditPassword'
import ActionButton from "../ActionButton.vue";
import {EventBus} from "src/eventBus";
import ModalReveal from "../../foundation/ModalReveal.vue";
import AddDriverFlagReveal from "./reveal/AddDriverFlagReveal.vue";

export default {
  name: 'DriverActionButtons',
  components: {AddDriverFlagReveal, ModalReveal, ActionButton},
  data() {
    return {
      entity: null
    }
  },
  created() {
    if (!this.driver) {
      KeplerBackofficeSdk.drivers.select(this.$route.params.id).get((item) => {
        this.entity = item
      })

    } else {
      this.entity = this.driver
    }
  },
  methods: {
    edit() {
      MaggieHelper.openRightPanel({
        component: DriverSmartEdit, props: {
          item: this.entity
        }
      })
    },
    setNewPassword() {
      this.entity.password = ''
      MaggieHelper.openRightPanel({
        component: DriverEditPassword, props: {
          item: this.entity
        }
      })
    },
    sendPasswordResetEmail() {
      this.$confirm('Are you sure?', 'Do you really want to send the password reset link to this driver?', () => {
        KeplerBackofficeSdk.drivers.select(this.entity).sendPasswordResetLink(() => {
          MaggieHelper.notification('Reset password:', 'An email for password reset has been sent', 'success')
        })
      })
    },
    suspend() {
      this.$confirm('Are you sure?', 'Do you really want to suspend this driver?', () => {
        KeplerBackofficeSdk.drivers.select(this.entity).suspend((response) => {
          this.entity = response
          const message = 'Driver ' + response.name + ' ' + response.surname + ' ' + 'has been Suspended'
          MaggieHelper.notification('Driver Suspension:', message, 'success')
        })
      })
    },
    approve() {
      KeplerBackofficeSdk.drivers.select(this.entity).approve((response) => {
        this.entity = response
        var message = 'Driver ' + response.name + ' ' + response.surname + ' ' + 'has been approved'
        MaggieHelper.notification('Driver Approval:', message, 'success')
        this.$nextTick(() => location.reload())
      })
    },

    reactivate() {
      KeplerBackofficeSdk.drivers.select(this.entity).reactivate((response) => {
        this.entity = response
        var message = 'Driver ' + response.name + ' ' + response.surname + ' ' + 'has been reactivated'
        MaggieHelper.notification('Driver Reactivation: ', message, 'success')
      })
    },

    deleteDriver() {
      this.$confirm('Are you sure?', 'Do you really want to delete this driver?', () => {
        KeplerBackofficeSdk.drivers.select(this.entity).delete((response) => {
          var message = 'Driver has been deleted'
          MaggieHelper.notification('Driver deletion: ', message, 'success')
        })
      })
    },
    deleteClientAccount() {
      const c = `kepler:delete-client-data client-id:${this.driver.client_id}`
      return KeplerBackofficeSdk.console.run(c, (ok) => {
        EventBus.$emit('reload-list')
      })
    }
  },
  computed: {
    canApprove() {
      return this.$acl('approve-drivers') && (this.entity.status === 'PENDING REVIEW' || this.entity.status === 'ON HOLD')
    },
    canReactivate() {
      return this.$acl('reactivate-drivers') && this.entity.status === 'SUSPENDED'
    },
    canSuspend() {
      return this.$acl('suspend-drivers') && this.entity.status === 'ACTIVE'
    },
    canDelete() {
      return this.$acl('delete-drivers') && this.entity.status === 'SUSPENDED'
    },
    canEdit() {
      return this.$acl('edit-drivers')
    },
    canResetPassword() {
      return this.$acl('reset-password-driver')
    },
    canSendResetPassword() {
      return this.$acl('send-reset-driver')
    },
    canDo() {
      return !this.pendingDelete && (this.canApprove || this.canReactivate || this.canSuspend || this.canDelete || this.canEdit || this.canResetPassword || this.canSendResetPassword)
    },

  },
  props: ['driver', 'item', 'pendingDelete']
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// DriverActionButtons.vue?1b4fbb8f